import type { PortfolioSort } from '@/features/actual-vs-budget/portfolio'
import type { ActualVsBudgetMetricKey } from '@/features/actual-vs-budget/types'

export interface PortfolioMatrixState {
  query: string
  fund: string
  sort: PortfolioSort
  visibleMetrics: ActualVsBudgetMetricKey[]
}

export function createDefaultPortfolioMatrixState(): PortfolioMatrixState {
  return {
    query: '',
    fund: 'all',
    sort: 'attention',
    visibleMetrics: ['revenue', 'adjusted-ebitda'],
  }
}
